import Accordion from "components/accordion/Accordion";
import React from "react";

function VisitSummaryAccordion({ accordionData }) {
  return <Accordion containerClassName="divide-y" data={accordionData} />;
}

export default VisitSummaryAccordion;
